import { computed, inject, onMounted, ref, type SetupContext } from "vue";
import { useI18n } from "vue-i18n";
import { appConfigProviderKey } from "../../../infrastructure/app_config_provider";
import html_iway from "./template.iway.html?raw";
import {
  whoamiApiKey,
  type WhoamiDto,
} from "../../../infrastructure/gfo_api/whoami_api";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("konfigurator" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
interface Props {
  checkerKeysCsv: string;
  className: string;
}

export default {
  template: html,
  components: {},
  props: {
    checkerKeysCsv: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: ""
    }
  },
  emits: {
    onCheckerResponse: (payload: { netz: string; checker_result_uid: string }) => {
      return typeof payload.netz === 'string' && typeof payload.checker_result_uid === 'string'
    }
  },
  setup(props: Props, { emit, expose }: SetupContext) {
    const { t } = useI18n();
    const appConfig = inject(appConfigProviderKey);
    const whoamiApi = inject(whoamiApiKey);
    const whoamiDto = ref<WhoamiDto | null>(null);
    const gfoCheckerRef = ref<any|null>(null);

    const checkerKeysCsv = computed(() => props.checkerKeysCsv);
    

    const currentUrl = computed(function () {
      return window.location.href;
    });

    const checkerTheme = computed(() => "light");

    const doFocus = function(){
      const el = gfoCheckerRef.value;
      if (!el) {return;}
      el.doFocus()
    }
    expose({doFocus})

    onMounted(async () => {
      const res = await whoamiApi?.getWhoami();
      if (typeof res !== "undefined") {
        whoamiDto.value = res;
      }
    });

    const handleCheckerResponse = async (evt: any) => {
      emit("onCheckerResponse", {
        netz: evt.detail?.netz ?? "",
        checker_result_uid: evt.detail?.checker_result_uid ?? "",
      });
    };

    return {
      t,
      appConfig,
      checkerKeysCsv,
      checkerTheme,
      doFocus,
      handleCheckerResponse,
      gfoCheckerRef,
      whoamiDto,
      currentUrl,
    };
  },
} as any;
